import type { ReactNode } from "react";
import type { UseQueryResult } from "@tanstack/react-query";
import { ErrorBanner, Spinner } from "./Feedback";

/**
 * Loading / error / data switch for a query, so screens only render the happy
 * path: <QueryState query={q}>{(data) => …}</QueryState>
 */
export function QueryState<T>({ query, children, loading }: {
  query: Pick<UseQueryResult<T>, "data" | "error" | "isLoading">; children: (data: T) => ReactNode;
  /** Page-shaped placeholder instead of the spinner. */
  loading?: ReactNode;
}) {
  if (query.isLoading) return <>{loading ?? <Spinner />}</>;
  if (query.data === undefined) return <ErrorBanner error={query.error ?? new Error("Không tải được dữ liệu")} />;
  return <>{children(query.data)}</>;
}
